import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { PrimaryButton } from "./button";

export default function AixmAirportExportButton({
  label,
  items = [],
  handleExportXML,
  isExportXMLLoading,
  isExportXMLDisabled,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOnExport = (item) => {
    handleClose();
    handleExportXML(item.value);
  };

  return (
    <>
      <PrimaryButton
        label={label}
        id="aixm-airportexport-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        isLoading={isExportXMLLoading}
        disabled={isExportXMLDisabled || isExportXMLLoading}
        onClick={handleClick}
      />
      <Menu
        id="export-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "aixm-airportexport-button",
        }}
      >
        {items.map((item) => (
          <MenuItem key={item.id} onClick={() => handleOnExport(item)}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
